import React, { useState } from 'react';
import { Form, Input, Button, Card, Tabs, Divider, Space } from 'antd';
import { GoogleOutlined, UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Login.module.css';

const { TabPane } = Tabs;

export default function Login() {
    const { signInWithGoogle, signInWithEmail, signUpWithEmail } = useAuth();
    const [loading, setLoading] = useState(false);

    const handleGoogleSignIn = async () => {
        setLoading(true);
        try {
            await signInWithGoogle();
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const handleEmailSignIn = async (values) => {
        setLoading(true);
        try {
            await signInWithEmail(values.email, values.password);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const handleEmailSignUp = async (values) => {
        setLoading(true);
        try {
            await signUpWithEmail(values.email, values.password, values.displayName);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    return (
        <div className={styles.loginContainer}>
            <Card className={styles.loginCard}>
                <div className={styles.header}>
                    <h2>❤ Money Lover</h2>
                    <p>Đăng nhập để bắt đầu quản lý tài chính của bạn</p>
                </div>

                <Button
                    type="primary"
                    icon={<GoogleOutlined />}
                    onClick={handleGoogleSignIn}
                    loading={loading}
                    size="large"
                    className={styles.googleButton}
                >
                    Đăng nhập với Google
                </Button>

                <Divider>Hoặc</Divider>

                <Tabs defaultActiveKey="signin">
                    <TabPane tab="Đăng nhập" key="signin">
                        <Form onFinish={handleEmailSignIn} layout="vertical">
                            <Form.Item
                                name="email"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập email!' },
                                    { type: 'email', message: 'Email không hợp lệ!' }
                                ]}
                            >
                                <Input
                                    prefix={<MailOutlined />}
                                    placeholder="Email"
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="Mật khẩu"
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    size="large"
                                    className={styles.submitButton}
                                >
                                    Đăng nhập
                                </Button>
                            </Form.Item>
                        </Form>
                    </TabPane>

                    <TabPane tab="Đăng ký" key="signup">
                        <Form onFinish={handleEmailSignUp} layout="vertical">
                            <Form.Item
                                name="displayName"
                                rules={[{ required: true, message: 'Vui lòng nhập tên hiển thị!' }]}
                            >
                                <Input
                                    prefix={<UserOutlined />}
                                    placeholder="Tên hiển thị"
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item
                                name="email"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập email!' },
                                    { type: 'email', message: 'Email không hợp lệ!' }
                                ]}
                            >
                                <Input
                                    prefix={<MailOutlined />}
                                    placeholder="Email"
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập mật khẩu!' },
                                    { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự!' }
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="Mật khẩu"
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    size="large"
                                    className={styles.submitButton}
                                >
                                    Đăng ký
                                </Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
}
